import css from './_.module.css'
import LFlex from "../../components/lui/layout/lflex/LFlex"
import {Link} from "react-router-dom"
import data from './data.json'
import AppState from "../../../domain/contexts/AppState"


/**
 *  @returns {JSX.Element}
 *  @constructor
 */
export default function PageMain() {

    const dict = data[ AppState.instance.lang ]

    return (
        <LFlex className='jc-center ai-center ac-center w100 h100'>
            <div className={css.container}>
                <img src={process.env.PUBLIC_URL + "/assets/i/logo.png"} alt="LoCode" className={css.logo}/>
                <div className={css.disclaimer}>Independent application development</div>
                <div className={css.text}>
                    <nobr>{ dict['dev'] }</nobr>
                    <a href="mailto:dev@locode.me" className={css.link}>dev@locode.me</a>
                </div>
                <div className={css.text}>
                    <Link to="projects" className={css.link}>{ dict['support']['btn'] }</Link>
                    <nobr>{ dict['support']['text'] }</nobr>
                </div>
            </div>
        </LFlex>
    )

}
